module.exports = __webpack_public_path__ + "static/media/youtube-icon.eae79f3f.png";